

export class FacultyMedicalProcedureCaseReviewParameterModel{

 Id:string;
 FacultyMedicalProcedureId:string;
 Name:string;


}

